import { useConfig } from "@jti/app-context/useConfig";

export type TaxesDisplaySettings = {
  showSimpleTotalBreakdown: boolean;
  showBreakdownWithNames: boolean;
};

export const useTaxesDisplayMode = (): TaxesDisplaySettings => {
  const mode = useConfig().taxesDisplayMode || "SimpleTotalBreakdown";

  return {
    showSimpleTotalBreakdown: mode === "SimpleTotalBreakdown" || mode === "Both",
    showBreakdownWithNames: mode === "BreakdownWithNames" || mode === "Both",
  };
};
